<app-alert-messages
  *ngIf="bResponseAlert"
  [resMessage]="resMessage"
></app-alert-messages>
<div>
  <div class="table-header-section" *ngIf="editingOption">
    <div class="d-flex align-items-center justify-content-between mb-2 mt-2">
      <div class="d-flex align-items-center ms-2">
        <!-- <span *ngIf="showSidebar" (click)="DataTableComponent_ToggleSidebar()">
            <i class="bi bi-list data-manager-sidebar-icon me-2"></i>
           </span> -->
        <span>
          <h6 class="mb-0 heading">{{ sTableName }}</h6>
        </span>
      </div>
      <div class="d-flex flex-wrap">
        <button
        *ngIf="bDataMangerEditableTable && editMode"
        class="btn btn-outline-secondary btn-sm me-2"
        aria-expanded="false"
        (click)="this.editMode=false"
      >
        <i class="fa-solid fa-arrow-left me-2"></i>Back
      </button>
          <span
            *ngIf="bDataMangerEditableTable && editMode"
            class="table-action-icon me-2"
            ngbTooltip="Copy all records to clipboard."
            placement="left"
            aria-expanded="false"
            (click)="DataTableComponent_CopyAllRecordstoClipBoard()"
          >
            <i class="fa-regular fa-copy"></i>
          </span>
  
          <span
          *ngIf="bDataMangerEditableTable && editMode"
          class="table-action-icon me-2"
            ngbTooltip="Add New Record"
            placement="left"
            aria-expanded="false"
            (click)="DataTablesComponent_AddNewRow()"
          >
            <i class="bi bi-database-fill-gear"></i>
          </span>
  
          <span
          *ngIf="bDataMangerEditableTable && editMode"
          class="table-action-icon me-2"
            ngbTooltip="Delete Record"
            placement="left"
            aria-expanded="false"
            (click)="
              sSelectedRow != ''
                ? DataTablesComponent_DisplayRevertChangesPopUpModal(
                    confirmDeleteRecord,
                    'delete'
                  )
                : ''
            "
          >
            <i class="fa-solid fa-trash"></i>
          </span>
  
          <span
          *ngIf="bDataMangerEditableTable && editMode"
          class="table-action-icon me-2"
            ngbTooltip="Revert Changes"
            placement="left"
            aria-expanded="false"
            (click)="
              sSelectedRow != ''
                ? DataTablesComponent_DisplayRevertChangesPopUpModal(
                    revertChangesPopUp,
                    'revert'
                  )
                : DataTablesComponent_ClearLocalStorageAttributes()
            "
          >
            <i class="fa-solid fa-rotate-left"></i>
          </span>
  
          <span
          *ngIf="bDataMangerEditableTable && editMode"
          class="table-action-icon me-2"
            ngbTooltip="Duplicate Record"
            placement="left"
            aria-expanded="false"
            (click)="DataTablesComponent_AddNewDuplicateRow()"
          >
            <i class="fa-solid fa-clone"></i>
          </span>
  
          <span 
          *ngIf="editMode"
            class="table-action-icon me-2"
            ngbTooltip="Refresh Data"
            placement="left"
            aria-expanded="false"
            (click)="
              DataTablesComponent_ResetDataTableAfterFiltering(oSelectedRecord)
            "
          >
            <i class="fa-solid fa-arrows-rotate"></i>
          </span>
  
          <span
            *ngIf="bDataMangerEditableTable && editMode"
            class="table-action-icon me-2"
            ngbTooltip="Save Record"
            placement="left"
            aria-expanded="false"
            (click)="
              DataTablesComponent_DisplayConfirmSaveRecord(confirmSavePopup)
            "
          >
            <i class="fa-solid fa-floppy-disk"></i>
          </span>
     
          <span
          *ngIf="bDataMangerEditableTable && !editMode"
          class="table-action-icon me-2"
          ngbTooltip="Edit Table"
          placement="left"
          aria-expanded="false"
          (click)="toggleView()">
          <i class="fa-regular fa-pen-to-square"></i>
        </span>
        
      </div>
    </div>
  </div>
  <div class="table-responsive data-manager-table" [ngClass]="editingOption == true ? 'data-manager-table-height' : 'data-source-table-height'" #scrollContainer>
    <table class="table table-bordered">
      <thead>
        <tr>
          <ng-container *ngFor="let data of lTableAttributes;let i = index">
            <th
                *ngIf="(!data.systemAttr || data.name === 'id') && data.listHidden == false && !data.dataManagerHidden"
                scope="col"
                sortData="data.name"
                [sortable]="data.name"
                [direction]="data.direction"
                [class.input-none]="bSelectMode"
                (sort)="DataTablesComponent_SortingColumn($event)"
                [ngClass]="{
                  'sticky-naming-header': data.naming === true && i==1
                }"
              >
                <div class="th-content">
                  <span class="th-text" [appEllipsisTitle]="data?.name">{{ data?.name }}</span>
                  <span class="th-icons">
                    <i class="bi bi-arrow-down-up ms-1" [ngClass]="data.direction == '' ? 'd-inline' : 'd-none'"></i>
                    <i class="bi bi-arrow-up ms-1" [ngClass]="data.direction == 'asc' ? 'd-inline' : 'd-none'"></i>
                    <i class="bi bi-arrow-down ms-1" [ngClass]="data.direction == 'desc' ? 'd-inline' : 'd-none'"></i>
                  </span>
                </div>
              </th>
    
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let data of lTableAttributes; let i = index">
            <th scope="col" *ngIf="(!data.systemAttr || data.name === 'id') && data.listHidden == false && !data.dataManagerHidden"   [ngClass]="{
              'sticky-naming-header': data.naming === true && i==1
            }">
              <input
                type="text"
                class="form-control"
                [placeholder]="data.name"
                [value]="data.value"
                (keyup)="DataTableComponent_SearchOnKeyUp($event)"
                (blur)="
                  DataTablesComponent_ClearTheCellNameForClosingDropDownofAutoSuggestion()
                "
                (click)="
                  DataTablesComponent_ClickOnInputForFilteredRecords(data.name)
                "
                (change)="DataTablesComponent_GetValuesFromInput($event, i)"
                (keydown)="
                  DataTablesComponent_FilterDataFromTablePressingEnter(
                    $event.keyCode,
                    $event,
                    i
                  )
                "
                [readonly]="bSelectMode"
              />
              <div
                class="list-group custom-dropdown-autocomplete shadow"
                [class.d-none]="sCellNameForDistinctValues != data.name"
              >
                <a
                  *ngFor="let sr of results"
                  href="javascript:void(0)"
                  class="list-group-item list-group-item-action"
                  (click)="
                    DataTablesComponent_SetValuesForSearchingReocrds(sr, i);
                    sCellNameForDistinctValues = ''
                  "
                  >{{ sr }}</a
                >
              </div>
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr
        *ngFor="let item of lTableRecords; let i = index"
        [ngClass]="
          editMode
            ? bSelectMode
              ? oSelectedRow[i] === true
                ? 'color-blue'
                : ''
              : sSelectedRow === item
                ? 'color-blue'
                : ''
            : ''
        "
      >
      
          <ng-container *ngFor="let column of lTableAttributes;let j = index">
            <td
            [ngClass]="{
              
            }"
              *ngIf="(!column.systemAttr || column.name === 'id') && column.listHidden == false  && !column.dataManagerHidden"
     [ngClass]="{
  'color-blue': editMode && (
                  (bSelectMode && oSelectedRow[i] === true) ||
                  (!bSelectMode && sSelectedRow === item)
                ),
  'sticky-naming': column.naming === true,
  'diagonal-icon-display': j==0 || (column.naming === true && j==1)
}"

              class="0-relative"
            >
              <div class="position-relative" >
                <i
                (click)="editMode ? 
                  DataTableComponent_OpenEditRowModal(item, editRowModal, i) : DataTablesComponent_GetTableRecordDetail(item, HtmlJsonModal, i)"
                class="fa-solid fa-up-right-and-down-left-from-center diagonal-icon"
                [ngbTooltip]=  "editMode ? 'Click to edit' : 'Click to view'"
                placement="top"
                container="body"
                aria-hidden="true"
              ></i>
                <input
                  class="newOne form-control"
                  [ngClass]="{
                    'text-white': editMode && (
                                    (bSelectMode && oSelectedRow[i]) ||
                                    (!bSelectMode && sSelectedRow === item)
                                 ),
                    'sticky-naming': column.naming === true,
                    'input-padding': j==0 || (column.naming === true && j==1)
                  }"
                  [class.input-error]="editing1[i + '-' + column?.prop]"
                  [value]="
                    item[column.prop] == undefined ? 'Null' : item[column.prop]
                  "
                  readonly
                  (click)="
                    (bDataMangerEditableTable == true && editMode)
                      ? DataTablesComponent_EditCell(
                          $event,
                          column?.prop,
                          i,
                          column,
                          item,
                          column?.inputPattern,
                          $event,
                          column?.patternMessage,
                          column?.inputType,
                          column?.editable
                        )
                      : ''
                  "
                  (keyup)="
                    (bDataMangerEditableTable == true && editMode)
                      ? DataTablesComponent_EditCell(
                          $event.keyCode,
                          column?.prop,
                          i,
                          column,
                          item,
                          column?.inputPattern,
                          $event,
                          column?.patternMessage,
                          column?.inputType,
                          column?.editable
                        )
                      : ''
                  "
                  *ngIf="!editing[i + '-' + column.prop]"
                />
                <ng-container *ngIf="visible && editMode" class="position-relative">
                  
                  <input
                    appArrowupdown
                    #myInput
                    list="SearchResults"
                    [readonly]="
                      (column?.editable == false &&
                        bEnablePrimaryKeyEditing == false) ||
                      (column?.primary == true &&
                        bEnablePrimaryKeyEditing == false) ||
                      (column?.prop == 'id' &&
                        column?.primary == true &&
                        bEnablePrimaryKeyEditing == false) ||
                      (column.autoComplete == true &&
                        column.acPermitsNewValue == false)
                    "
                    (blur)="
                      DataTablesComponent_UpdateSelectedCellValue(
                        $event,
                        column?.prop,
                        i,
                        column?.inputType
                      )
                    "
                    (keyup.enter)="
                      DataTablesComponent_UpdateSelectedCellValue(
                        $event,
                        column?.prop,
                        i,
                        column?.inputType
                      )
                    "
                    *ngIf="editing[i + '-' + column?.prop]"
                    [type]="column?.inputType"
                    [attr.maxLength]="column?.valueLength"
                    class="activeInputField form-control"
                    [value]="
                      item[column.prop] == undefined
                        ? 'Null'
                        : item[column.prop]
                    "
                    min="{{ '1-1-2022' | date : 'yyyy-MM-dd' }}"
                    max="{{ '12-31-2032' | date : 'yyyy-MM-dd' }}"
                    [pattern]="column?.inputPattern"
                    (keyup)="
                      DataTableComponent_OnKeyPress(
                        $event,
                        column?.inputPattern,
                        column?.prop,
                        column?.patternMessage,
                        i
                      )
                    "
                    (keyup)="DataTableComponent_SearchOnKeyUp($event)"
                    [ngClass]="
                      editing1[i + '-' + column?.prop] ? 'input-error' : ''
                    "
                  />
                  <div
                    class="list-group custom-dropdown-autocomplete shadow"
                    *ngIf="
                      editing[i + '-' + column?.prop] &&
                      column.autoComplete == true
                    "
                  >
                    <a
                      *ngFor="let sr of results"
                      href="javascript:void(0)"
                      class="list-group-item list-group-item-action"
                      (click)="
                        DataTablesComponent_UpdateSelectedCellValueFor(
                          sr,
                          column?.prop,
                          i,
                          column?.inputPattern,
                          column?.patternMessage
                        )
                      "
                      >{{ sr }}</a
                    >
                  </div>
                </ng-container>
              </div>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    <div *ngIf="lTableRecords.length == 0 && !bLoading">
      <div class="d-flex align-items-center justify-content-center mt-3">
        <small class="heading">No Data Found!</small>
      </div>
    </div>
  </div>
  <div
    class="py-3 px-2 d-flex justify-content-end data-manager-pagination view-pagination"
    *ngIf="lTotalElements > 0"
  >
    <div
      class="row"
      (click)="
        newArray && newArray.length > 0
          ? DataTableComponent_ShowErrorUnsavedRecords('Pagination')
          : ''
      "
    >
      <ngb-pagination
        [collectionSize]="lTotalElements"
        [maxSize]="5"
        (pageChange)="DataTableComponent_GetPageFromService($event)"
        [disabled]="(newArray && newArray.length > 0) || bSelectMode"
        [(page)]="nCurrentPage"
        [pageSize]="nDataTableSize"
        aria-label="Default pagination"
        size="sm"
      ></ngb-pagination>
    </div>
  </div>
</div>
<!-- ----------------- -->
<!-- Componenets Model -->
<!-- ----------------- -->

<!-- Revert Changes table modal -->
<ng-template #revertChangesPopUp let-modal>
  <div class="modal-header">
    <h4 class="modal-title modal-header-font">Revert Changes</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="DataTableComponent_DismissModal()"
    ></button>
  </div>
  <div class="modal-body">
    <div class="table" style="overflow: auto; max-height: calc(100% - 80px)">
      <span>Are you sure you want to revert your changes?</span>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-end gap-1">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="
        modal.dismiss('Cross click'); DataTablesComponent_RevertChangesModal()
      "
    >
      Ok
    </button>
  </div>
</ng-template>

<ng-template #confirmSavePopup let-modal>
  <div class="modal-header">
    <h4 class="modal-title modal-header-font">Save Changes</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button> -->
  </div>
  <div class="modal-body">
    <div class="table" style="overflow: auto; max-height: calc(100% - 80px)">
      <span>Are you sure you want to save your changes?</span>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-end gap-1">
    <button
      type="button"
      class="btn btn-outline-secondary gap-3"
      (click)="modal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="
        modal.dismiss('Cross click'); DataTablesComponent_SaveEditReocrds()
      "
    >
      Ok
    </button>
  </div>
</ng-template>

<!-- Confiration Delete Record modal -->
<ng-template #confirmDeleteRecord let-modal>
  <div class="modal-header">
    <h4 class="modal-title modal-header-font">Delete Confirmation</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button> -->
  </div>
  <div class="modal-body">
    <div class="table" style="overflow: auto; max-height: calc(100% - 80px)">
      <p class="sub-heading">
        Are you sure you want to delete the selected record?
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <div class="text-right">
      <button
        type="button"
        class="btn btn-outline-secondary me-2"
        (click)="modal.dismiss('Cross click')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="
          DataTablesComponent_DeleteRecord(); modal.dismiss('Cross click')
        "
      >
        Delete
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editRowModal let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title">Edit Row</h3>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button> -->
  </div>
  <div class="modal-body settings-table">
    <form>
      <div class="mb-2">
        <div class="row editable-modal-height">
          <ng-container *ngFor="let item of lModalEditRows; let i = index">
            <div class="col-6 mb-2" *ngIf="item.dataManagerHidden == false">
              <label class="mb-1" for="name{{ i }}">{{ item.KeyName }}</label>
              <input
                appArrowupdown
                list="SearchResults"
                type="{{ item?.inputType }}"
                [readonly]="
                  item?.editable == false ||
                  (item?.autoComplete == true &&
                    item.acPermitsNewValue == false)
                "
                [attr.maxLength]="item?.valueLength"
                class="activeInputField form-control"
                [(ngModel)]="item.keyValue"
                [ngModelOptions]="{ standalone: true }"
                min="{{ '1-1-2022' | date : 'yyyy-MM-dd' }}"
                max="{{ '12-31-2032' | date : 'yyyy-MM-dd' }}"
                [pattern]="item?.inputPattern"
                [ngClass]="
                  editingForModel[i + '-' + item?.prop] ? 'input-error' : ''
                "
                (click)="
                  DataTableComponent_AutoCompleteSuggestionValueForModel(
                    item?.prop,
                    i
                  )
                "
                (blur)="
                  DataTableComponent_CloseAutoCompleteSuggestionValueDropDownForModel(
                    item?.prop,
                    i
                  )
                "
                (keyup)="
                  DataTableComponent_OnKeyPressForModal(
                    $event,
                    item?.inputPattern,
                    item?.prop,
                    i
                  );
                  DataTableComponent_CheckValidity();
                  DataTableComponent_SearchOnKeyUp($event)
                "
              />
              <small
                *ngIf="editingForModel[i + '-' + item?.prop] === true"
                class="text-danger"
                >{{ item?.patternMessage }}</small
              >
              <div
                class="list-group custom-dropdown-autocomplete-modal shadow"
                *ngIf="
                  editingForAutoSuggestion[i + '-' + item?.prop] &&
                  item.autoComplete == true
                "
              >
                <ng-container *ngFor="let sr of results">
                  <a
                    *ngIf="sr != ''"
                    href="javascript:void(0)"
                    class="list-group-item list-group-item-action"
                    (click)="
                      DataTablesComponent_UpdateSelectedCellValueForModel(
                        sr,
                        item?.prop,
                        i,
                        item?.inputPattern
                      )
                    "
                    >{{ sr }}</a
                  >
                </ng-container>
                <a
                  *ngIf="searchArray.length == 0"
                  href="javascript:void(0)"
                  class="list-group-item list-group-item-action"
                  >No Item Found.</a
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary me-2"
      [disabled]="bModelUpdateButton"
      (click)="
        modal.close('Save click'); DataTableComponent_UpdateTableRowValues()
      "
    >
      Update
    </button>
  </div>
</ng-template>



<!-- HtmlJsonModal -->

<ng-template #HtmlJsonModal let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title">{{sTableName}}</h3>
 
      <button type="button" class="btn-close" aria-label="Close" 
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body settings-table">
    <form>
      <div class="mb-2">
        <div class="row split-area-fields" *ngIf="lModalEditRows.length > 0">
          <ng-container *ngFor="let item of lModalEditRows; let i = index">
            <div class="split-field" *ngIf="item.dataManagerHidden == false">
              <div class="field-container">
                <label class="mb-1 ml-2 field-name" for="name{{ i }}">{{ item.KeyName }}</label>
                <div class="fields px-2 py-2 d-flex justify-content-between align-items-center">
                  <input 
                    type="{{ item?.inputType }}" 
                    [readonly]="true"
                    [attr.maxLength]="item?.valueLength" 
                    class="activeInputField form-control readOnly-input scroll-input"
                    [(ngModel)]="item.keyValue"
                    [ngModelOptions]="{ standalone: true }" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        
        <!-- Hidden/ListHidden Fields (Textarea or Pre) -->
        <div class="row split-area-fields mt-3" *ngIf="lHiddenModalEditRows.length > 0">
          <ng-container *ngFor="let item of lHiddenModalEditRows; let i = index">
            <div class="split-field">
              <div class="field-container">
                <label class="mb-1 field-name" for="hidden{{ i }}">{{ item.KeyName }}</label>
                <textarea
                  [readonly]="true"
                  class="form-control resizeable-textarea"
                  [(ngModel)]="item.keyValue"
                  [ngModelOptions]="{ standalone: true }"
                  rows="5">
                </textarea>
                <!-- Alternatively:
                <pre class="resizeable-pre">{{ item.keyValue }}</pre>
                -->
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
    <div *ngIf="createdHtml != undefined" class="divider div-transparent"></div>
    <div>
      <div  *ngIf="createdHtml != undefined"  class="jsonHtml page-preview content-view mt-0 p-2" [innerHtml]="createdHtml ">
      </div>
  </div>
  </div>

</ng-template>
